module.exports = __webpack_public_path__ + "img/cornell.60b92298.jpg";